import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
    GET_ADMIN_ORDERS: '/api/order/admin/get_admin_orders',
    GET_ADMIN_ORDER_BY_ID : '/api/order/admin/get_admin_order',
    ADMIN_ORDER_STATUS_UPDATE : '/api/order/admin/admin_order_status_update',
    GET_SELLER_ORDERS: '/api/order/seller/get_seller_orders',
    GET_SELLER_ORDER_BY_ID : '/api/order/seller/get_seller_order',
    SELLER_ORDER_STATUS_UPDATE : '/api/order/seller/seller_order_status_update',

};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

export const get_admin_orders = createAsyncThunk(
    "order/get_admin_orders",
    async ({ searchValue, parPage, page, status}, { rejectWithValue, fulfillWithValue }) => {
       // console.log('status', status);
        try {
            const { data } = await api.get(API_ROUTES.GET_ADMIN_ORDERS+`?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,  {
                params: { status }, // Add status as a query parameter if needed
                withCredentials: true
            });
           //console.log("Réponse de l'API orders infos :", data);
           return fulfillWithValue(data);
        } catch (error) {
               console.error("Erreur lors de d'ajout d'un ami : ", error);
               return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const get_seller_orders = createAsyncThunk(
    "order/get_seller_orders",
    async ({ searchValue, parPage, page, status, sellerId}, { rejectWithValue, fulfillWithValue }) => {
       // console.log('status', status);
        try {
            const { data } = await api.get(API_ROUTES.GET_SELLER_ORDERS+`/${sellerId}?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,  {
                params: { status }, // Add status as a query parameter if needed
                withCredentials: true
            });
           //console.log("Réponse de l'API orders infos :", data);
           return fulfillWithValue(data);
        } catch (error) {
               console.error("Erreur lors de d'ajout d'un ami : ", error);
               return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const get__admin_order = createAsyncThunk(
    "order/get__admin_order",
    async ({orderId}, { rejectWithValue, fulfillWithValue }) => {
      // console.log('order id from get order', orderId);
        try {
            const { data } = await api.get(API_ROUTES.GET_ADMIN_ORDER_BY_ID+`/${orderId}`, 
                {   params: { orderId },
                     withCredentials: true });
            //console.log('api response getting order', data);
            return fulfillWithValue(data);
        } catch (error) {
            //console.log('error geting order', error);
            return rejectWithValue(getErrorMessage(error));
            
        }
    }
)

export const admin_order_status_update = createAsyncThunk(
    "order/admin_order_status_update",
    async ({orderId, info}, { rejectWithValue, fulfillWithValue }) => {
      // console.log('order id from get order', orderId);
        try {
            const { data } = await api.put(API_ROUTES.ADMIN_ORDER_STATUS_UPDATE+`/${orderId}`, info,
                {   params: { orderId },
                     withCredentials: true });
            //console.log('api response getting order', data);
            return fulfillWithValue(data);
        } catch (error) {
            //console.log('error geting order', error);
            return rejectWithValue(getErrorMessage(error));
            
        }
    }
)

export const get_seller_order = createAsyncThunk(
    "order/get_seller_order",
    async ({orderId}, { rejectWithValue, fulfillWithValue }) => {
      // console.log('order id from get order', orderId);
        try {
            const { data } = await api.get(API_ROUTES.GET_SELLER_ORDER_BY_ID+`/${orderId}`, 
                {   params: { orderId },
                     withCredentials: true });
            //console.log('api response getting order', data);
            return fulfillWithValue(data);
        } catch (error) {
            //console.log('error geting order', error);
            return rejectWithValue(getErrorMessage(error));
            
        }
    }
)

export const seller_order_status_update = createAsyncThunk(
    "order/seller_order_status_update",
    async ({orderId, info}, { rejectWithValue, fulfillWithValue }) => {
      // console.log('order id from get order', orderId);
        try {
            const { data } = await api.put(API_ROUTES.SELLER_ORDER_STATUS_UPDATE+`/${orderId}`, info,
                {   params: { orderId },
                     withCredentials: true });
            //console.log('api response getting order', data);
            return fulfillWithValue(data);
        } catch (error) {
            //console.log('error geting order', error);
            return rejectWithValue(getErrorMessage(error));
            
        }
    }
)


// Reducer principal
export const ordersReducer = createSlice({
    name: "order",
    initialState: {
        successMessage: "",
        messageError: "",
        loader: false,
        orderInfo : {},
        MyOrders : [],
        order : {},
        totalOrders : 0,
    },
    reducers: {
        setOrderInfo: (state, action) => {
            state.orderInfo = action.payload;
        },
        messageClear: (state) => {
            state.messageError = "";
            state.successMessage = "";
        },
    
    },
   
    extraReducers: (builder) => {
        builder
        .addCase(get_admin_orders.pending, (state) => {
            state.loader = true;
            state.messageError = "";
        })
        .addCase(get_admin_orders.fulfilled, (state, action) => {
            state.loader = false;
            state.MyOrders = action.payload.orders;
            state.totalOrder = action.payload.totalOrder;
            
        })
        .addCase(get_admin_orders.rejected, (state, action) => {
            state.loader = false;
            state.messageError = action.payload;
        })
        .addCase(get__admin_order.pending, (state) => {
            state.loading = true;
            state.messageError = ''
          })
          .addCase(get__admin_order.fulfilled, (state, action) => {
            state.loading = false;
            state.order = action.payload.order;
            state.successMessage = action.payload.message;
          })
          .addCase(get__admin_order.rejected, (state, action) => {
            state.loading = false;
            state.messageError = action.payload.message;
          })
          .addCase(admin_order_status_update.rejected, (state, action) => {
            state.loading = false;
            state.messageError = action.payload.message;
          })
          .addCase(admin_order_status_update.fulfilled, (state, action) => {
            state.loading = false;
            state.successMessage = action.payload.message;
          })
          .addCase(admin_order_status_update.pending, (state) => {
            state.loading = true;
            state.messageError = ''
          })
          .addCase(get_seller_orders.pending, (state) => {
            state.loader = true;
            state.messageError = "";
        })
        .addCase(get_seller_orders.fulfilled, (state, action) => {
            state.loader = false;
            state.MyOrders = action.payload.orders;
            state.totalOrders = action.payload.totalOrders;
            
        })
        .addCase(get_seller_orders.rejected, (state, action) => {
            state.loader = false;
            state.messageError = action.payload;
        })
        .addCase(get_seller_order.pending, (state) => {
            state.loading = true;
            state.messageError = ''
          })
          .addCase(get_seller_order.fulfilled, (state, action) => {
            state.loading = false;
            state.order = action.payload.order;
            state.successMessage = action.payload.message;
          })
          .addCase(get_seller_order.rejected, (state, action) => {
            state.loading = false;
            state.messageError = action.payload.message;
          })
          .addCase(seller_order_status_update.rejected, (state, action) => {
            state.loading = false;
            state.messageError = action.payload.message;
          })
          .addCase(seller_order_status_update.fulfilled, (state, action) => {
            state.loading = false;
            state.successMessage = action.payload.message;
          })
          .addCase(seller_order_status_update.pending, (state) => {
            state.loading = true;
            state.messageError = ''
          })

        
    },
   
});

export const { setOrderInfo, messageClear} = ordersReducer.actions;
export default ordersReducer.reducer;
